import { render } from "./FormPreview.vue?vue&type=template&id=be2a45e0&scoped=true"
import script from "./FormPreview.vue?vue&type=script&lang=ts"
export * from "./FormPreview.vue?vue&type=script&lang=ts"

import "./FormPreview.vue?vue&type=style&index=0&id=be2a45e0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-be2a45e0"

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QForm,QImg,QAvatar,QInput,QSelect,QOptionGroup,QBtn,QField,QRadio,QCheckbox,QIcon});
